"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_ACCOUNT_FEATURE_FLAGS = exports.ACCOUNT_PARCEL_FIELD_NAME_OVERRIDES = exports.UPDATE_ACCOUNT_LOGO = exports.UPDATE_ACCOUNT = exports.ACCOUNT_INFO = void 0;
const client_1 = require("@apollo/client");
exports.ACCOUNT_INFO = (0, client_1.gql) `
  query getAccountInfo {
    account {
      id
      name
      state
      crsEnabled
      logoUrl
      initialFIRMDate
      coastalADetermination
      datumConversionOffsetPurpose
      datumConversionOffset
      repetitiveLossEnabled
      datums
    }
  }
`;
exports.UPDATE_ACCOUNT = (0, client_1.gql) `
  mutation UpdateAccount($data: UpdateAccountInput!) {
    updateAccount(data: $data) {
      id
      initialFIRMDate
      repetitiveLossEnabled
      coastalADetermination
      datumConversionOffsetPurpose
      datumConversionOffset
    }
  }
`;
exports.UPDATE_ACCOUNT_LOGO = (0, client_1.gql) `
  mutation UpdateAccountLogo($data: UpdateAccountLogoInput!) {
    updateAccountLogo(data: $data) {
      id
      logoUrl
    }
  }
`;
exports.ACCOUNT_PARCEL_FIELD_NAME_OVERRIDES = (0, client_1.gql) `
  query getAccountParcelFieldNameOverrides {
    account {
      id
      parcelFieldNameOverrides {
        name
        value
        isPublic
      }
    }
  }
`;
exports.UPDATE_ACCOUNT_FEATURE_FLAGS = (0, client_1.gql) `
  mutation UpdateAccountFeatureFlags($data: [UpdateAccountFeatureFlagInput!]!) {
    updateAccountFeatureFlags(data: $data) {
      featureFlags {
        id
        updatedAt
        isEnabled
        feature
        name
        description
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,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